/**
* Nom : Menu.js
* Description : Ce fichier contient la définition de la page Menu 
*               Cette page affiche un menu visuel à l'accueil de l'application 
*               pour naviguer vers une des deux sections de l'application
* Date de création : 20 février 2025
*/

/* CSS et assets */
import { ImgMenuRD } from 'package_ui_ihm/dist'
import { ImgMenuCustomers } from 'package_ui_ihm/dist'

/* Bibliothèques et composants */
import { Link } from 'react-router-dom'

/* Hook */
import { useScreenWidth } from 'package_ui_ihm/dist';


/**
* Menu : affiche une page avec deux liens représenter par des images pour naviguer dans l'application
*
* Type : page 
*
* Parametres : 
*  None
*/
function Menu() {

    // Define useScreenWidth hooks
    const screenWidth = useScreenWidth();


    // Render component
    return (
        <div className={(screenWidth > 650) ? 'App' : 'App-ss'}>
            <div className={(screenWidth > 650) ? 'flex-row justify-center' : 'flex-column justify-center'}>
                <Link to='/targets' className='link-menu'>
                    <img src={ImgMenuRD} alt='goto_R&D_section' className={(screenWidth > 1200) ? 'link-img-menu' : 'link-img-menu-ss'}/>
                </Link>
                <Link to='/equipments' className='link-menu'>
                    <img src={ImgMenuCustomers} alt='goto_customers_section' className={(screenWidth > 1200) ? 'link-img-menu' : 'link-img-menu-ss'} />
                </Link>
            </div>
        </div>
    );
}

export default Menu;

